import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ContractService } from 'src/app/contract/shared/contract.service';

import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, map, startWith, take } from 'rxjs';
import { UserService } from 'src/app/shared/user.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-add-clause',
  templateUrl: './add-clause.component.html',
  styleUrls: ['./add-clause.component.css']
})
export class AddClauseComponent implements OnInit {
  @ViewChild('contractInput') contractInput!: ElementRef<HTMLInputElement>;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;


  contractTypes: any;
  filteredOptions: Observable<string[]>;
  isNotFound: boolean = false;
  clauseForm: any = FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  id: string;
  formLoading: boolean = false;
  clause: any;
  languages = [{
    id: 1, name: "English"
  }]
  mode: any;

  constructor(public contractService: ContractService, public userService: UserService, private router: Router, private formBuilder: FormBuilder, private toast: ToastrService, private _ngZone: NgZone, private route: ActivatedRoute) {

    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.mode = params['mode'];
    });

    if (this.id)
      this.formLoading = true;

    this.clauseForm = this.formBuilder.group({
      contractTypeName: ['', [Validators.required]],
      contractTypeId: [0],
      version: [1],
      description: [''],
      language_Id: [null, [Validators.required]],
      name: ['', [Validators.required]],
      text: ['', [Validators.required]],
      isMandatory: [false],
      isTracked: [false],
    });

    if (this.mode == 'view') 
      this.clauseForm.disable();
    else 
      this.clauseForm.enable();
  }

  triggerResize() {
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  async ngOnInit() {
    await this.contractService.getContractTypes().then((res: any) => {
      this.contractTypes = res;
    })

    if (this.contractTypes) {
      this.filteredOptions = this.clauseForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter(((value as string)) || ''))
      );
    }

    if (this.id) {
      await this.contractService.getClause(parseInt(this.id)).then((clause: any) => {
        this.clause = clause;
      });

      this.clauseForm.patchValue(this.clause);

      const selectedLanguage = this.languages.find(option => option.id === this.clause.language_Id);
      if (selectedLanguage)
        this.clauseForm.get('language_Id').setValue(selectedLanguage.id);

      this.formLoading = false;
    }
  }

  private _filter(value: string): any[] {
    this.isNotFound = false;
    const filterValue = value.toLowerCase();
    const results = this.contractTypes.filter(option => option.name.toLowerCase().includes(filterValue));
    if (results.length === 0)
      this.isNotFound = true

    return results;
  }

  onInputChange(value: string) {
    this.filteredOptions = this.clauseForm.get('contractTypeName').valueChanges.pipe(
      startWith(value),
      map(val => this._filter((val as string) || ''))
    );
  }

  reset() {
    this.clauseForm.reset();
  }

  onContractTypeSelect(event) {
    this.clauseForm.get('contractTypeName').setValue(event.option.value.name);
    this.clauseForm.get('contractTypeId').setValue(event.option.value.contractTypeId);

    if (this.contractTypes) {
      this.filteredOptions = this.clauseForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter((value as string) || ''))
      );
    }
  }

  submitClause() {
    if (this.clauseForm.valid) {
      this.isLoading = true;
      const formData = this.clauseForm.value;
      if (this.id) {
        formData.oldText = this.clause.text;
        this.contractService.updateClause(formData, this.id).then((res) => {
          this.toast.success('The clause has been updated successfully!', '');
          this.reset();
          this.router.navigate(['app/clause/']);
          this.isLoading = false;
        });
      } else {
        this.contractService.saveClauses(formData).then((res) => {
          this.toast.success('The clause has been created successfully!', '');
          this.reset();
          this.router.navigate(['app/clause/']);
          this.isLoading = false;
        });
      }
    }
  }
}
